import { publicBase2v } from '@App/dicts/pathes'

export class Public {
    contacts = (ipIds: number[]) => publicBase2v(`contacts/${ipIds}`)
}
